import React from 'react';
import { Container} from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { PricingPresentation } from './billing';
import Page from 'components/page';
import { Paths } from "paths";

const Pricing = () => {
  const [t] = useTranslation('common');

  return (
    <Page title={t('Pricing Plans and Subscription Options')} description={t('Explore our flexible pricing plans and subscription options designed to meet your needs. Find the perfect package for your budget and requirements.')} canonicalUrl={Paths.Pricing.path}>
      <Container className="min-vh-100 my-5">
          <PricingPresentation/>
      </Container>
    </Page>
  );
};

export default Pricing;